<template>
  <div class="table-responsive">
    <div class="container-table">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th nowrap class="text-center" width="50">Alterado por</th>
            <th nowrap class="text-center" width="10">Ação</th>
            <th nowrap class="text-center" width="50">Campos alterados</th>
            <th nowrap class="text-center" width="10">Data</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="audit in data">
            <tr
              data-toggle="collapse"
              :data-target="'#fields' + audit.id"
              class="clickable pointer"
              :key="audit.id"
            >
              <td class="text-center">{{ audit.user.name }}</td>
              <td class="text-center">{{ audit.event | audit_event }}</td>
              <td class="text-center">
                {{ (audit.event == 'updated' ? audit.new_values : {}) | audit_fields_contract }}
              </td>
              <td class="text-center">{{ audit.created_at | date }}</td>
            </tr>
            <tr class="collapse out" :id="'fields' + audit.id" :key="'values' + audit.id">
              <td colspan="4">
                <CustomerContractPlanHistoryValuesTable :audit="audit" />
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { returnMessageFormMixin } from '@/mixins/returnMessageFormMixin.js';
import { baseApiUrl } from '@/global';
import axios from 'axios';
import CustomerContractPlanHistoryValuesTable from '@/components/contracts/plans/CustomerContractPlanHistoryValuesTable';

export default {
  mixins: [returnMessageFormMixin],
  name: 'CustomerContractPlanHistory',
  components: { CustomerContractPlanHistoryValuesTable },
  data() {
    return {
      data: [],
      page: 1,
    };
  },
  methods: {
    convertFilters() {
      const filters = `?page=${this.page ? this.page : 1}`;
      return filters;
    },
    getDatas() {
      const url = `${baseApiUrl}/v1/audits/contract-plan/${
        this.contractId
      }/${this.convertFilters()}`;
      axios(url).then((res) => {
        this.data = res.data;
      });
    },
  },
  beforeMount() {
    if (this.contractId) {
      this.getDatas();
    }
  },
  computed: {
    contractId() {
      return this.$store.state.showContractSave;
    },
  },
};
</script>
